import axios from "axios";
import { API } from "../../../App";
import { todayStr } from "./diUtils";

// Aviso ao registar um voo sem reserva ativa desta aeronave, neste dia, para o piloto ou o instrutor do voo.
// Não bloqueia o registo: só pergunta. Voos de dias passados não são avisados, como nas anomalias.
export async function confirmarSemReserva({ aircraft, date, pilotId, instructorId }) {
  if (!aircraft || !date || date < todayStr()) return true;
  try {
    const { data } = await axios.get(`${API}/di/reservations/check`, {
      params: {
        aircraft_registration: aircraft,
        flight_date: date,
        pilot_id: pilotId || undefined,
        instructor_id: instructorId || undefined,
      },
      withCredentials: true,
    });
    if (data?.tem_reserva) return true;
  } catch {
    return true; // se a verificação falhar, não impede o registo
  }
  return window.confirm("Este voo não tem reserva ativa desta aeronave neste dia. Registar mesmo assim?");
}
